<template>
  <div
    :class="[
      'form-wizard-layout',
      {
        'form-wizard-layout--footer-visible': isFooterVisible,
        'form-wizard-layout--sidebar-visible': isSideBarVisible,
        'form-wizard-layout--sidebar-mobile-menu-visible': isSideBarMobileMenuVisible
      }
    ]"
  >
    <header class="form-wizard-layout__header">
      <slot name="header"></slot>
    </header>

    <main class="form-wizard-layout__body">
      <aside class="form-wizard-layout__body__sidebar">
        <slot name="sidebar"></slot>
      </aside>

      <div class="form-wizard-layout__body__content">
        <div class="form-wizard-layout__body__content__inner" :class="['size-' + containerSize]">
          <slot name="main"></slot>
        </div>
      </div>

      <div class="form-wizard-layout__body__preview">
        <slot name="preview" />
      </div>
    </main>

    <footer class="form-wizard-layout__footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FormWizardLayout',
  props: {
    isFooterVisible: Boolean,
    isSideBarVisible: Boolean,
    isSideBarMobileMenuVisible: Boolean,
    containerSize: {
      type: String,
      default: 'default'
    }
  }
};
</script>

<style lang="scss">
.form-wizard-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: #fff;

  &__body {
    flex: 1 1 auto;
    display: flex;
    background: #fff;
    position: relative;
    min-height: 0;

    $transition: all 175ms ease-out;

    &__sidebar {
      display: none;
      flex: 0 0 auto;
      // margin-left: -16rem;
      margin-left: -16rem;
      width: 16rem;
      // width: 16rem;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding: 2.8rem 1rem 2rem 2rem;
      transition: $transition;
      min-height: 0;
      background-color: $gray-100;
    }

    &__content {
      flex: 1 1 auto;
      padding: 2.8rem 2rem 4rem;
      // padding: 2.8rem 3.5rem 4rem;
      background: #fff;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      align-items: flex-start;
      transition: $transition;
      min-height: 0;
      position: relative;

      &__inner {
        position: relative;
        // max-width: 750px;
        max-width: 976px;
        margin: 0 auto;

        &.size-large {
          max-width: 1020px;
        }
      }

      @include media-breakpoint-down(sm) {
        padding: 5%;
      }
    }

    &__preview {
      display: none;
      flex: 0 0 auto;
      overflow: hidden;
      width: $preview-width;
      margin-right: -$preview-width;
      transition: $transition;
      position: relative;
      border-left: 1px solid $border-color;
      box-sizing: content-box;
      opacity: 0;
    }
  }

  &__footer {
    position: fixed;
    z-index: 20;
    flex: 0 0 auto;
    border-top: 1px solid #f5f5f5;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: $footer-height;
    transform: translate3d(0, 110%, 0);
    transition: all 375ms ease;
  }

  &--sidebar-visible & {
    &__body__sidebar {
      margin-left: 0;
    }

    &__body__preview {
      margin-right: 0;
      opacity: 1;
    }
  }

  &--footer-visible & {
    &__body {
      padding-bottom: $footer-height;
    }

    &__footer {
      transform: translate3d(0, 0, 0);
    }
  }

  @include media-breakpoint-up(md) {
    &__body__sidebar {
      display: block;
    }
  }

  @include media-breakpoint-down(sm) {
    &__body__sidebar {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
      bottom: 0;
      overflow-y: auto;
      width: 100%;
      z-index: 100;
      transform: translate(-100%, 0) !important;
      @include transition();
    }

    &--sidebar-mobile-menu-visible & {
      &__body__sidebar {
        transform: translate(0, 0) !important;
      }
    }
  }

  @media (min-width: 1350px) {
    &__body__preview {
      display: flex;
    }
  }

  @include media-breakpoint-down(xs) {
    &__footer {
      height: rem(80px);
    }

    &--footer-visible & {
      &__body {
        padding-bottom: rem(80px);
      }
    }
  }
}
</style>
